import { useTranslation } from 'react-i18next';
import styles from './ReconnectingBanner.module.css';

export function ReconnectingBanner() {
    const { t } = useTranslation();

    return (
        <div className={styles.banner}>
            <div className={styles.spinner} />
            <span>{t('gamepad.reconnecting')}</span>
        </div>
    );
}
